import { getErrorMessage } from '@juvare/common-web-ui/utils';
import { Alert, Box, CircularProgress, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useSearchParams } from 'react-router';
import { useAlertUiTranslation } from '../../../../hooks';
import { useAlert } from '../../hooks';
import { AlertDeliveryAndResponse } from './components/AlertDeliveryAndResponse';
import { AlertDetails } from './components/AlertDetails';
import { AlertHeader } from './components/AlertHeader';
import { AlertSummary } from './components/AlertSummary';
export const AlertView = ({ id, onReload, onCloseDialog }) => {
    var _a;
    const { t } = useAlertUiTranslation();
    const { data, isLoading, error, mutate } = useAlert(id);
    const statusLikeSent = ['sent', 'sending', 'failed', 'archived'].includes((_a = data === null || data === void 0 ? void 0 : data.status) !== null && _a !== void 0 ? _a : '');
    let tab = 'deliveryAndResponse';
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedTab, setSelectedTab] = React.useState(false);
    React.useEffect(() => {
        setSelectedTab(false);
    }, [data === null || data === void 0 ? void 0 : data.id]);
    if (searchParams.get('message') === 'true') {
        tab = 'message';
    }
    const boxRef = React.useRef();
    React.useEffect(() => {
        if (boxRef.current && !!(data === null || data === void 0 ? void 0 : data.id)) {
            boxRef.current.focus();
        }
    }, [data === null || data === void 0 ? void 0 : data.id]);
    return (React.createElement(Box, { ref: boxRef, tabIndex: 0 },
        React.createElement(AlertHeader, { data: data, onReload: (clearActiveAlert) => {
                if (!clearActiveAlert) {
                    mutate().finally(() => undefined);
                }
                onReload(clearActiveAlert);
            }, onCloseDialog: onCloseDialog !== null && onCloseDialog !== void 0 ? onCloseDialog : (() => undefined) }),
        !data && isLoading && (React.createElement(Box, { sx: { px: 2, py: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(CircularProgress, null))),
        !data && error && (React.createElement(Box, { p: 2, pb: 8 },
            React.createElement(Alert, { severity: 'error' }, getErrorMessage(error)))),
        data && (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2, p: 2, pt: 0 } },
            React.createElement(AlertSummary, { data: data }),
            statusLikeSent ? (React.createElement(React.Fragment, null,
                React.createElement(Tabs, { value: tab, onChange: (_event, newTab) => {
                        if (newTab === 'deliveryAndResponse') {
                            setSearchParams((prev) => {
                                const next = new URLSearchParams(prev);
                                next.delete('message');
                                return next;
                            }, { replace: true });
                        }
                        else {
                            setSearchParams((prev) => {
                                const next = new URLSearchParams(prev);
                                next.set('message', 'true');
                                return next;
                            }, { replace: true });
                        }
                    } },
                    React.createElement(Tab, { label: t('common.deliveryAndResponse'), value: 'deliveryAndResponse', onClick: () => setSelectedTab(true) }),
                    React.createElement(Tab, { label: t('common.message'), value: 'message', onClick: () => setSelectedTab(true) })),
                tab === 'deliveryAndResponse' && (React.createElement(AlertDeliveryAndResponse, { data: data, onReload: mutate, isTabSelected: selectedTab })),
                tab === 'message' && React.createElement(AlertDetails, { isTabSelected: selectedTab, data: data }))) : (React.createElement(AlertDetails, { data: data }))))));
};
